import React from 'react'
import { Button } from '@material-ui/core'
import { Translate } from 'react-localize-redux'
import PropTypes from 'prop-types'
import useStyles from './styles'

const SubscriptionPlanActionButton = ({
  isCurrent,
  hasSubscription,
  onSubscribe,
  onUpdate,
  disabled,
}) => {
  const classes = useStyles()

  return (
    <>
      {isCurrent ? (
        <Button
          color="primary"
          variant="contained"
          className={classes.button}
          disabled
        >
          Current
        </Button>
      ) : (
        <Button
          color="primary"
          variant="contained"
          className={classes.button}
          disabled={disabled}
          onClick={hasSubscription ? onUpdate : onSubscribe}
        >
          {hasSubscription ? (
            <Translate id="plans.update-plan" />
          ) : (
            <Translate id="plans.subscribe" />
          )}
        </Button>
      )}
    </>
  )
}

SubscriptionPlanActionButton.propTypes = {
  isCurrent: PropTypes.bool.isRequired,
  hasSubscription: PropTypes.bool.isRequired,
  onSubscribe: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
}

export default SubscriptionPlanActionButton
